import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useState, useEffect } from 'react';

export default function Home() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
    {
      image: './post/img1.jpg',
      title: 'Liderança Estratégica',
      subtitle: 'em Sustentabilidade',
      description: 'Transformamos a sustentabilidade num eixo estratégico de crescimento, competitividade e impacto positivo, através de soluções corporativas integradas e orientadas a resultados.'
    },
    {
      image: './post/img2.jpg',
      title: 'Excelência Corporativa',
      subtitle: 'e Impacto Sustentável',
      description: 'Parceria estratégica que une expertise técnica e gestão corporativa para impulsionar o crescimento sustentável.'
    },
    {
      image: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/b553a748042f33ea80856a695f2187a9.jpeg',
      title: 'Soluções Corporativas',
      subtitle: 'Integradas',
      description: 'Do diagnóstico à implementação — oferecemos consultoria completa para empresas que buscam excelência.'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) return;

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d59nv3lcrgmf5papd4h0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('✅ Email enviado com sucesso! Entraremos em contacto em breve.');
        setEmail('');
      } else {
        setSubmitMessage('❌ Erro ao enviar. Por favor, tente novamente.');
      }
    } catch (error) {
      setSubmitMessage('❌ Erro ao enviar. Por favor, tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section with Carousel */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Carousel Images */}
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url('${slide.image}')` }}
            ></div>
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>
        ))}

        {/* Carousel Controls */}
        <button
          onClick={prevSlide}
          className="hidden md:flex absolute left-8 z-20 w-12 h-12 items-center justify-center bg-transparent backdrop-blur-sm rounded-full hover:bg-white/20 transition-all cursor-pointer"
          aria-label="Anterior"
        >
          <i className="ri-arrow-left-s-line text-2xl text-white"></i>
        </button>
        <button
          onClick={nextSlide}
          className="hidden md:flex absolute right-8 z-20 w-12 h-12 items-center justify-center bg-transparent backdrop-blur-sm rounded-full hover:bg-white/20 transition-all cursor-pointer"
          aria-label="Próximo"
        >
          <i className="ri-arrow-right-s-line text-2xl text-white"></i>
        </button>

        {/* Carousel Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-3">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                index === currentSlide ? 'bg-[#CB9832] w-8' : 'bg-white/50 hover:bg-white/70'
              }`}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white w-full">
          <div className="max-w-3xl">
            <h1 className="font-bold leading-tight mb-6">
              <span className="block text-4xl md:text-5xl lg:text-6xl">{heroSlides[currentSlide].title}</span>
              <span className="block text-4xl md:text-5xl lg:text-6xl text-[#CB9832] mt-2">{heroSlides[currentSlide].subtitle}</span>
            </h1>
            <p className="text-lg md:text-base text-white/90 leading-relaxed mb-8 max-w-2xl">
              {heroSlides[currentSlide].description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contato"
                className="inline-flex items-center justify-center bg-[#234A32] text-white px-8 py-3.5 rounded-full font-semibold text-base transition-all shadow-xl whitespace-nowrap cursor-pointer"
              >
                CONTACTE-NOS
                <i className="ri-arrow-right-line ml-2 text-lg"></i>
              </Link>
              <Link
                to="/servicos"
                className="inline-flex items-center justify-center border-2 border-white bg-transparent text-white px-8 py-3.5 rounded-full font-semibold text-base hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
              >
                CONHEÇA OS SERVIÇOS
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-[#666666] text-sm font-semibold tracking-wider uppercase mb-3">NOSSAS SOLUÇÕES</p>
            <h2 className="text-4xl md:text-4xl font-bold text-[#1A1A1A]">
              Actuação Integrada e Estratégica
              <br />
              <span className="italic text-[#CB9832]">em Sustentabilidade</span>
            </h2>
            <p className="text-base text-gray-600 mt-6 max-w-3xl mx-auto leading-relaxed">
              Do diagnóstico estratégico à implementação, desenvolvemos soluções estruturadas que integram sustentabilidade, inovação e desempenho organizacional, assegurando impacto mensurável e resultados sustentáveis.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-plant-line',
                title: 'Projectos de Impacto',
                
                description:
                  'Concepção e implementação de projectos estruturantes que promovem impacto económico, social e ambiental, alinhados às prioridades institucionais e aos ODS.',
              },
              {
                icon: 'ri-lightbulb-line',
                title: 'Consultoria Estratégica',
                description:
                  'Apoiamos organizações na definição de estratégias de sustentabilidade, ESG e inovação, através de diagnósticos, planos de acção e acompanhamento técnico especializado.',
              },
              {
                icon: 'ri-graduation-cap-line',
                title: 'Formação e Capacitação',
                description:
                  'Programas de formação executiva e técnica, desenhados para fortalecer competências organizacionais, promover mudança cultural e assegurar implementação eficaz das estratégias definidas.',
              },
              {
                icon: 'ri-shopping-cart-line',
                title: 'Procurement',
                description:
                  'Apoiamos organizações na estruturação e optimização dos seus processos de procurement, assegurando eficiência, transparência e alinhamento estratégico.',
              },
              {
                icon: 'ri-megaphone-line',
                title: 'Marketing e Comunicação Integrada',
                description:
                  'Desenvolvemos estratégias de comunicação institucional e de impacto, garantindo coerência entre posicionamento, reputação e práticas sustentáveis da organização.',
              },
              {
                icon: 'ri-calendar-event-line',
                title: 'Eventos Corporativos',
                description:
                  'Concepção e gestão de eventos estratégicos, fóruns e iniciativas institucionais criando experiências disruptivas, com foco no objectivo definido.',
              },
            ].map((service, index) => (
              <div
                key={index}
                className="bg-[#F8F8F8] rounded-xl p-6 hover:shadow-2xl transition-all group cursor-pointer"
              >
                <div className="w-12 h-12 mb-4 flex items-center justify-center bg-[#2D5F3F] rounded-lg group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#1A1A1A] mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
                            
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/servicos"
              className="inline-flex items-center justify-center bg-[#2D5F3F] text-white px-8 py-4 rounded-full font-bold text-base hover:bg-[#234A32] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              VER TODOS OS SERVIÇOS
              <i className="ri-arrow-right-line ml-2 text-lg"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Lead Generation Section */}
      <section className="relative py-32 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=diverse%20black%20african%20business%20professionals%20team%20collaboration%20meeting%20discussing%20sustainability%20projects%20modern%20bright%20office%20natural%20lighting%20professional%20attire%20confident%20leadership%20green%20plants%20eco-friendly%20workspace%20teamwork%20partnership&width=1920&height=800&seq=cta-kudima-sustain-black-new-006&orientation=landscape')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-3">TRANSFORME O SEU NEGÓCIO</h2>
          <p className="text-base md:text-lg mb-10 leading-relaxed">
            Agende uma consultoria especializada e descubra como integrar a sustentabilidade na estratégia do seu negócio, gerando valor, eficiência e impacto a longo prazo.
          </p>

          <form 
            id="newsletter-consultoria"
            data-readdy-form
            onSubmit={handleSubmit} 
            className="max-w-2xl mx-auto"
          >
            <div className="flex flex-col sm:flex-row gap-4 bg-white/20 backdrop-blur-sm p-2 rounded-full">
            
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Adicione o seu E-mail"
                className="flex-1 bg-transparent border-none outline-none text-white placeholder-white/70 px-6 py-3 text-lg"
                required
                disabled={isSubmitting}
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-[#234A32] text-white px-8 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'A enviar...' : (
                  <>
                    AGENDAR CONSULTORIA
                    <i className="ri-arrow-right-line text-lg"></i>
                  </>
                )}
              </button>
            </div>
            
            {submitMessage && (
              <p className="mt-4 text-white text-lg font-medium">
                {submitMessage}
              </p>
            )}
          </form>
        </div>
      </section>

      {/* Partners Carousel Section */}
      <section className="py-24 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="inline-block bg-[#CB9832]/10 text-[#CB9832] px-4 py-2 rounded-full text-sm font-semibold mb-4">
              PARCEIROS
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
              Empresas que Confiam
            </h2>
            <h2 className="text-4xl md:text-5xl text-black mb-6">
              na Nossa Expertise
            </h2>
            
          </div>

          {/* Partners Carousel */}
          <div className="relative overflow-hidden">
            <div className="flex animate-scroll">
              {[...Array(2)].map((_, setIndex) => (
                <div key={setIndex} className="flex gap-12 px-6">
                  {[
                    'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/f20017d8ebf11c27910229e0278b3bca.jpeg',
                    'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/66b0babf79a42af54894099634d033b2.jpeg',
                    'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/8818884cc240a8528ae5f35cbf833e90.jpeg',
                    'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/8e1f1567de9ecede5df2d4d061a40d68.jpeg',
                    'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/43e7cbe9b444a910e570a6a750bfa45e.jpeg',
                    'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/b642e3ed2875398379a3e6bc59e773e2.jpeg',
                    'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/839d8c21c008ac45f2a3fa7d8e68f1eb.png',
                  ].map((logo, index) => (
                    <div
                      key={`${setIndex}-${index}`}
                      className="flex-shrink-0 w-48 h-24 flex items-center justify-center bg-white rounded-xl p-4 shadow-sm"
                    >
                      <img
                        src={logo}
                        alt={`Parceiro ${index + 1}`}
                        className="w-full h-full object-contain grayscale hover:grayscale-0 transition-all"
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/parceiros"
              className="inline-flex items-center text-[#CB9832] font-semibold hover:underline cursor-pointer text-lg"
            >
              Ver Todos os Parceiros
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-2">
              <span className="inline-block border border-gray-300 text-gray-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                +KUDIMA
              </span>
              <h2 className="text-4xl md:text-5xl font-bold mb-4">
                Soluções Ponta-a-Ponta
              </h2>
              <p className="text-[#4A4A4A] leading-relaxed text-lg mb-6">
                Actuamos de forma integrada e estratégica, oferecendo soluções completas, desde o diagnóstico e planeamento até à execução, monitorização e comunicação de impacto.
              </p>
              <Link
                to="/quem-somos"
                className="inline-flex items-center text-[#CB9832] font-semibold hover:underline cursor-pointer"
              >
                CONHEÇA A NOSSA HISTÓRIA
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>

              <div className="grid grid-cols-2 gap-6 mt-8">
                <div className="bg-[#F8F8F8] rounded-xl p-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#CB9832]/10 rounded-lg mb-3">
                    <i className="ri-plant-line text-2xl text-[#CB9832]"></i>
                  </div>
                  <p className="text-gray-700 font-semibold text-sm">Impacto Sustentável</p>
                </div>
                <div className="bg-[#F8F8F8] rounded-xl p-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#CB9832]/10 rounded-lg mb-3">
                    <i className="ri-team-line text-2xl text-[#CB9832]"></i>
                  </div>
                  <p className="text-gray-700 font-semibold text-sm">Parcerias Estratégicas</p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-3 relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <div className="w-full h-64 rounded-2xl overflow-hidden shadow-lg">
                    <img
                      src="https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/6791a5a9fdfaae173c655955746232d2.jpeg"
                      alt="Equipa Kudima"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                <div className="space-y-4 pt-12">
                  <div className="w-full h-80 rounded-2xl overflow-hidden shadow-lg">
                    <img
                      src="https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/aa28349d37d0de9497ee76c99a321392.jpeg"
                      alt="Projetos Kudima"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
